module.exports = __webpack_public_path__ + "static/media/d4.985ee245.png";